import { Icon, Link, SpaceBetween } from '@amzn/awsui-components-core';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectGeneralSupportLink } from 'src/app/AppMetadataSelector';

export const XPTFooter: React.FC = () => {
  const generalSupportLink = useSelector(selectGeneralSupportLink);

  const onSupportClick = useCallback(() => {
    generalSupportLink && window.open(generalSupportLink, '_blank');
  }, [generalSupportLink]);

  return (
    <div className="footer" id="f">
      <SpaceBetween direction="horizontal" size="xs" alignItems="center">
        <Link color="inverted" variant="secondary" fontSize="body-s" onFollow={onSupportClick}>
          <SpaceBetween direction="horizontal" size="xs">
            <span>Support</span>
            <Icon name="external" size="small" />
          </SpaceBetween>
        </Link>
      </SpaceBetween>
    </div>
  );
};
